import { render } from "./SkillLogosComponent.vue?vue&type=template&id=ebc902d8&ts=true"
import script from "./SkillLogosComponent.vue?vue&type=script&lang=ts"
export * from "./SkillLogosComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__